
import '../components/about/about.scss'

import { Helmet } from 'react-helmet'

import Experience from '../components/about/Experience'
import Services from '../components/about/Services'
import Testimonials from '../components/about/Testimonials'


function About() {
  return (
    <>
      <Helmet>
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/landing/assets/js/home_6_scripts.js"></script>
        <script src="/about/assets/js/home_1_scripts.js"></script>
      </Helmet>
      

      <Experience />
      <Services />

       <Testimonials />
    </>
  )
}

export default About
